module.exports = __webpack_public_path__ + "static/profile-f119f95dc9dbc694a57e1ae2e1580dc1.png";